module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#gallery",
      toString: function () {
        return this.url;
      }
    }